// extracted by mini-css-extract-plugin
module.exports = {"description":"card-description_description__GWDMn"};